import { addDays } from './addDays';
import { getDifferenceInSeconds } from './getDifferenceInSeconds';
import { getLocalMidnight } from './getLocalMidnight';
import { getStartOfYear } from './getStartOfYear';
var midnight = getLocalMidnight();
var yesterday = addDays(midnight, -1);
var startOfWeek = addDays(midnight, -6);
var startOfYear = getStartOfYear();
export function getTimestampType(date) {
    var timespan = getDifferenceInSeconds(date);
    if (timespan >= -60 * 55 && timespan < -60 * 1) {
        /* between 55 min and 1 min in future */
        return 9 /* TimestampType.InMinutes */;
    }
    else if (timespan >= -60 * 60 * 24 && timespan < -60 * 55) {
        /* between 24 h and 55 min in future */
        return 10 /* TimestampType.InHours */;
    }
    else if (timespan < 0) {
        return 0 /* TimestampType.None */;
    }
    else if (timespan < 60 * 2) {
        /* less than 2 minutes */
        return 1 /* TimestampType.JustNow */;
    }
    else if (timespan < 3600) {
        /* 2 minutes - 1 hour */
        return 2 /* TimestampType.LessThanOneHour */;
    }
    else if (date >= midnight) {
        /* Today */
        return 3 /* TimestampType.Today */;
    }
    else if (date >= yesterday) {
        /* Yesterday */
        return 4 /* TimestampType.Yesterday */;
    }
    else if (date >= startOfWeek) {
        /* In current week */
        return 5 /* TimestampType.ThisWeek */;
    }
    else if (date >= startOfYear) {
        /* In current year */
        return 6 /* TimestampType.ThisYear */;
    }
    else {
        return 7 /* TimestampType.FullDate */;
    }
}
//# sourceMappingURL=getTimestampType.js.map